module.exports = __webpack_public_path__ + "static/media/electricista.031bed6a.png";